import { $Qll } from './query-selector';

window.filterTagAction = (element) => {
  const target = element;
  const childs = $Qll('& > *', element.parentNode);
  childs.forEach((child) => {
    const childNode = child;
    childNode.dataset.active = false;
  });

  target.dataset.active = true;
};
